<h1 mat-dialog-title><strong>Importer des candidats dans le groupe</strong></h1>

<form #f="ngForm" (ngSubmit)="submit()">
  <div mat-dialog-content>
    <input
      (change)="fileBrowseHandler($event.target.files)"
      class="form-control mt-1 mb-3"
      id="importFile"
      name="importFile"
      required
      accept="text/csv"
      type="file" />
    <div class="input-group">
      @if (!isSubmitOk) {
      <div class="d-flex align-items-center pb-1">
        <span class="material-symbols-outlined pe-1">warning</span>
        Consignes :
      </div>
      <ul>
        <li>
          <small> La taille maximale autorisée du fichier est de 1 MB. </small>
        </li>
        <li>
          <div class="d-flex flex-row flex-center">
            <small class="pe-1">Pour télécharger un template : </small>
            <a
              class="d-flex text-decoration-none"
              href="assets/CandidatDatasettemplate.csv"
              download="CandidateDataset - template">
              <span class="material-symbols-outlined">download</span>
              <u>Template</u>
            </a>
          </div>
        </li>
      </ul>
      } @else {
      <div class="card mb-3">
        <div class="row g-0">
          <div class="col-3 align-self-center">
            <div class="d-flex justify-content-center align-items-center align-content-center">
              <img class="download" src="assets/images/download.png" alt="image of download" />
            </div>
          </div>
          <div class="col-9">
            <div class="card-body ps-0 p-2">
              <h5 class="card-title fs-6 m-0">{{ candidatesFile.item(0).name }}</h5>
              <div class="card-text">
                <div class="row">
                  <div class="col">
                    <span class="badge rounded-pill text-bg-primary">{{ candidatesFile.item(0).type }}</span>
                  </div>
                </div>
              </div>
              <div class="card-text">
                <small class="text-muted">{{ candidatesFile.item(0).lastModified | date : "dd/MM/YYYY" }}</small>
                <br />
                <small class="text-muted">{{ formatBytes(candidatesFile.item(0).size, 2) }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
  </div>

  <mat-dialog-actions class="justify-content-end">
    <button mat-dialog-close mat-raised-button>Annuler</button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!isSubmitOk">Importer</button>
  </mat-dialog-actions>
</form>
